import React from 'react'
import { Redirect } from 'common-tools/ReachRouter'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import Loadable from 'react-loadable'
import { LoadableLoading } from 'common-controls/App/LoadableLoading'

const Demo = Loadable({
  loader: () => import('common-controls/Demo/Demo'),
  loading: (props) => {
    return <LoadableLoading {...props} />
  }
})

class DemoRoutePlain extends React.Component {
  render () {
    const { SessionToken, location } = this.props

    if (!SessionToken) {
      return <Redirect from='/Demo' to={`/Login?returnURL=${location ? location.pathname : ''}`} />
    }

    return React.createElement(Demo, this.props)
  }
}

export const DemoRoute = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(DemoRoutePlain)
